import { render, staticRenderFns } from "./AppDisclaimer.vue?vue&type=template&id=da3dffba&scoped=true&"
import script from "./AppDisclaimer.vue?vue&type=script&lang=js&"
export * from "./AppDisclaimer.vue?vue&type=script&lang=js&"
import style0 from "./AppDisclaimer.vue?vue&type=style&index=0&id=da3dffba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da3dffba",
  null
  
)

export default component.exports